import * as React from "react"

const SvgSparkle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m20.425 7.854-.59 1.354a.366.366 0 0 1-.67 0l-.59-1.354-1.355-.59a.366.366 0 0 1 0-.671l1.355-.59.59-1.354a.366.366 0 0 1 .67 0l.59 1.355 1.355.589a.366.366 0 0 1 0 .671zm-3.589 13.354.589-1.354 1.355-.59a.366.366 0 0 0 0-.671l-1.355-.59-.59-1.354a.366.366 0 0 0-.67 0l-.59 1.355-1.355.589a.366.366 0 0 0 0 .672l1.355.588.59 1.355a.366.366 0 0 0 .67 0Z" />
    <path
      fillRule="evenodd"
      d="M9.186 18.242a.359.359 0 0 0 .628 0l2.126-3.873 3.874-2.126a.359.359 0 0 0 0-.629L11.94 9.488 9.814 5.615a.359.359 0 0 0-.628 0L7.06 9.488l-3.874 2.126a.359.359 0 0 0 0 .63l3.874 2.125zm3.044-6.313-1.763.967-.967 1.763-.967-1.763-1.763-.967 1.763-.968L9.5 9.2l.967 1.762z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgSparkle
